import { View } from "react-native";

export function ItemSeparator({ size = 16 }: { size?: number }) {
  return <View style={{ height: size }} />;
}
